export default __webpack_public_path__ + "static/media/port-alamo.41ca627b.webp";